function getAzureOpenAIConfig() {
  const endpoint = process.env.REACT_APP_SM_API_ENDPOINT_SWE;
  const key = process.env.REACT_APP_SM_API_KEY_AZURE_AI;
  const apiVersion = process.env.REACT_APP_SM_API_VERSION_SWE || '2024-05-01-preview';
  
  if (!endpoint || !key) {
    throw new Error('Faltan credenciales de Azure OpenAI en el entorno.');
  }
  
  return { endpoint: endpoint.replace(/\/$/, ''), key, apiVersion };
}

export async function uploadFileToAzureOpenAI(file: File): Promise<string> {
  const { endpoint, key, apiVersion } = getAzureOpenAIConfig();
  const url = `${endpoint}/openai/files?api-version=${apiVersion}`;

  const formData = new FormData();
  formData.append('purpose', 'assistants');
  formData.append('file', file);

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'api-key': key,
    },
    body: formData,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(`Error al subir archivo a Azure OpenAI: ${err.error?.message || res.statusText}`);
  }

  const data = await res.json();
  return data.id; // file_id
}

export async function createVectorStore(fileId: string, storeName: string): Promise<string> {
  const { endpoint, key, apiVersion } = getAzureOpenAIConfig();
  const url = `${endpoint}/openai/vector_stores?api-version=${apiVersion}`;

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'api-key': key,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name: storeName,
      file_ids: [fileId],
      expires_after: {
        anchor: 'last_active_at',
        days: 365,
      },
    }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(`Error al crear Vector Store: ${err.error?.message || res.statusText}`);
  }

  const data = await res.json();
  return data.id; // vector_store_id
}

export async function addFileToVectorStore(vectorStoreId: string, fileId: string): Promise<void> {
  const { endpoint, key, apiVersion } = getAzureOpenAIConfig();
  const url = `${endpoint}/openai/vector_stores/${vectorStoreId}/files?api-version=${apiVersion}`;

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'api-key': key,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      file_id: fileId
    }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(`Error al vincular archivo al Vector Store: ${err.error?.message || res.statusText}`);
  }
}

export async function removeFileFromVectorStore(vectorStoreId: string, fileId: string): Promise<void> {
  const { endpoint, key, apiVersion } = getAzureOpenAIConfig();
  const url = `${endpoint}/openai/vector_stores/${vectorStoreId}/files/${fileId}?api-version=${apiVersion}`;

  const res = await fetch(url, {
    method: 'DELETE',
    headers: {
      'api-key': key,
    },
  });

  if (res.status === 404) return;

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(`Error al eliminar archivo del Vector Store: ${err.error?.message || res.statusText}`);
  }
}

export async function deleteVectorStore(vectorStoreId: string): Promise<void> {
  const { endpoint, key, apiVersion } = getAzureOpenAIConfig();
  const url = `${endpoint}/openai/vector_stores/${vectorStoreId}?api-version=${apiVersion}`;

  const res = await fetch(url, {
    method: 'DELETE',
    headers: {
      'api-key': key,
    },
  });

  if (res.status === 404) return;

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(`Error al eliminar Vector Store: ${err.error?.message || res.statusText}`);
  }
}

export async function deleteAzureOpenAIFile(fileId: string): Promise<void> {
  const { endpoint, key, apiVersion } = getAzureOpenAIConfig();
  const url = `${endpoint}/openai/files/${fileId}?api-version=${apiVersion}`;

  const res = await fetch(url, {
    method: 'DELETE',
    headers: {
      'api-key': key,
    },
  });

  if (res.status === 404) return;

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(`Error al eliminar archivo de Azure OpenAI: ${err.error?.message || res.statusText}`);
  }
}
